import React, { useState } from 'react';
import { MoreOutlined } from '@ant-design/icons';
import Popover, { MenuItem } from './style';
import { ClickOut } from '..';

const Index = (props) => {
  const {
    items = [],
    className,
    optionIcon,
    minWidth,
    placement = 'bottomRight',
  } = props;

  const [isShow, setIsShow] = useState(false);

  return (
    <Popover
      visible={isShow}
      placement={placement}
      title=""
      className={className ?? ''}
      onClick={() => {
        setIsShow(true);
      }}
      content={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <ClickOut
          onClickOutside={() => {
            setIsShow(false);
          }}
        >
          <div>
            {items.map((item, index) => {
              return (
                <MenuItem
                  minWidth={minWidth}
                  key={item.id}
                  onClick={() => {
                    if (item?.onClick) {
                      item.onClick();
                    }
                    setIsShow(false);
                  }}
                  className={`${item.type || ''} ${
                    index === items.length - 1 && 'last'
                  }`}
                >
                  <div className="component_action_menu_popover_icon">
                    {item.icon}
                  </div>
                  <div className="font-paragraph ">{item.text}</div>
                </MenuItem>
              );
            })}
          </div>
        </ClickOut>
      }
      trigger="click"
    >
      {optionIcon || <MoreOutlined />}
    </Popover>
  );
};

export default Index;
